define.alias("shared/utils/string-formatters/dashed-to-camel", "calendar/utils/string-formatters/dashed-to-camel");